// @flow
import React, { PureComponent } from 'react';
import MatchResult from 'components/match/MatchResult';

import { STATUS_SUCCESS } from 'constants/statusConstants';
import type { MatchForMatchOfTheWeekType, MatchResultType } from 'types/MatchResult';
import type { Status } from 'types/Status';
import { formatFullDateForAgregateur } from 'utils/dateUtils';

export type StateProps = {
  allMatchesForMatchOfTheWeek: MatchForMatchOfTheWeekType[],
  ligue_id: number,
  match_semaine: number | false,
  result: MatchResultType,
  status: Status
};

export type DispatchProps = {
  fetchAllMatchesForMatchOfTheWeek: (structure: number, dateMinusAWeek: string, datePlusAWeek: string) => void,
  fetchMatchResultOfTheWeek: (match_semaine: number) => void
};

type Props = StateProps & DispatchProps;

class WeekMatchResult extends PureComponent<Props> {
  componentDidMount() {
    const { allMatchesForMatchOfTheWeek, ligue_id, match_semaine } = this.props;

    // get all matches of the week to either display the one chosen in BO or an existing match if admin hasn't changed BO
    const today = new Date();
    const dateMinusAWeek = formatFullDateForAgregateur(new Date(today.setDate(today.getDate() - 7)));
    const datePlusAWeek = formatFullDateForAgregateur(new Date(today.setDate(today.getDate() + 7)));

    this.props.fetchAllMatchesForMatchOfTheWeek(ligue_id, dateMinusAWeek, datePlusAWeek);

    // match of the week data
    if (allMatchesForMatchOfTheWeek) {
      let matchOfTheWeek = 0;

      if (
        match_semaine &&
        match_semaine !== 0 &&
        allMatchesForMatchOfTheWeek.find(match => match.id === match_semaine)
      ) {
        matchOfTheWeek = match_semaine;
      } else {
        allMatchesForMatchOfTheWeek.find(match => match.Competition.ClasseAge.nomWeb === 'Seniors');
      }
      if (matchOfTheWeek && parseInt(matchOfTheWeek, 10) > 0) {
        this.props.fetchMatchResultOfTheWeek(matchOfTheWeek);
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { allMatchesForMatchOfTheWeek, match_semaine } = this.props;

    // match of the week data
    if (prevProps.allMatchesForMatchOfTheWeek !== allMatchesForMatchOfTheWeek) {
      let matchOfTheWeek = 0;

      if (
        match_semaine &&
        match_semaine !== 0 &&
        allMatchesForMatchOfTheWeek.find(match => match.id === match_semaine)
      ) {
        matchOfTheWeek = match_semaine;
      } else {
        matchOfTheWeek = allMatchesForMatchOfTheWeek.find(match => match.Competition.ClasseAge.nomWeb === 'Seniors')
          ? allMatchesForMatchOfTheWeek.find(match => match.Competition.ClasseAge.nomWeb === 'Seniors')?.id
          : 0;
      }
      if (matchOfTheWeek && parseInt(matchOfTheWeek, 10) > 0) {
        this.props.fetchMatchResultOfTheWeek(matchOfTheWeek);
      }
    }
  }

  render() {
    const { result, status } = this.props;

    if (status === STATUS_SUCCESS && this)
      return <MatchResult result={result} title="Rencontre de la semaine" small={false} />;

    return '';
  }
}

export default WeekMatchResult;
